export const mapStatus = {
  Aprobado: "approved",
  Pendiente: "pending",
  Cancelado: "cancelled",
  Preparando: "preparing",
} as const;

export const mapLedgerType = {
  settlement: { label: "Liquidación", color: "green" as const },
  payoutBatch: { label: "Dispersión", color: "palomma" as const },
  payoutRefund: { label: "Reembolso dispersión", color: "orange" as const },
  withdrawal: { label: "Retiro", color: "palomma" as const },
  withdrawalRefund: { label: "Reembolso retiro", color: "orange" as const },
  topUp: { label: "Carga de fondos", color: "green" as const },
} as const;

export const mapPayoutStatus = {
  Pendiente: "pending",
  Procesando: "processing",
  Completado: "completed",
  Cancelado: "cancelled",
  Rechazado: "declined",
} as const;

export const mapWithdrawalStatus = {
  Pendiente: "pending",
  Procesando: "processing",
  Completado: "completed",
  Cancelado: "cancelled",
} as const;

export const mapMovementSourceType = {
  Liquidación: "settlement",
  Dispersión: "payoutBatch",
  "Reembolso dispersión": "payoutRefund",
  Retiro: "withdrawal",
  "Reembolso retiro": "withdrawalRefund",
  "Carga de fondos": "topUp",
} as const;

export const mapPayoutBatchStatus = {
  Aprobado: "approved",
  Pendiente: "pending",
  "Sin fondos": "unfunded",
  "Fondos en camino": "funding",
  Cancelado: "cancelled",
  Preparando: "preparing",
} as const;

export const formatSettlement = (topUp: {
  settlementDate?: string;
  settlementTime?: string;
}) => {
  if (!topUp.settlementDate || !topUp.settlementTime)
    return "al liquidar el ciclo PSE";
  const hour = new Intl.DateTimeFormat("es-CO", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(2000, 0, 1, Number(topUp.settlementTime)));

  const settlementDay = new Date(`${topUp.settlementDate}T12:00:00`);
  if (settlementDay.toDateString() === new Date().toDateString())
    return `hoy a las ${hour}`;
  const day = new Intl.DateTimeFormat("es-CO", {
    day: "numeric",
    month: "long",
  }).format(settlementDay);
  return `el ${day} a las ${hour}`;
};

export const mapPayoutBatchType = {
  owner: { label: "Propietarios", color: "blue" as const },
  buildingManagement: { label: "Administraciones", color: "purple" as const },
} as const;
